import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { TemplatesComponent } from './templates.component';
import { TemplatesRoutesModule } from './templates.routes';
import { TinymceModule } from 'angular2-tinymce';
import { TemplatesModalModule } from './modals/templates-modal.module';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/imagetools/plugin';
import { baseUrl } from '../../environments/environment';
import { SharedPopoverModule } from '../shared/popover/popover.module';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';

@NgModule({
    imports: [
        BaseModule,
        TemplatesRoutesModule,
        TinymceModule.withConfig({
            plugins: ['image', 'imagetools', 'code'],
            images_upload_url: baseUrl + 'image-upload',
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect image code | removeformat',
            extended_valid_elements: 'span'
        }),
        TemplatesModalModule,
        SharedPopoverModule,
        BreadcrumbModule
    ],
    declarations: [
        TemplatesComponent
    ]
})
export class TemplatesModule {
}
